import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { useDebounce } from "use-debounce";
import Input from "../../components/input";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const BulkViewOrgProducts = () => {
  const axiosInstance = useAxiosInstance();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({ data: [] });
  const [userSearch, setUserSearch] = useState("");
  const [userQuery] = useDebounce(userSearch, 1000);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .post("/accounts/all_report_types/", {
        page: 1,
        page_size: 9999999999,
        search_query: userQuery,
        is_sandbox: true,
      })
      .then((res) => {
        setLoading(false);
        const newData = [];
        res.data.data.forEach((reportType) => {
          newData.push({ ...reportType, id: reportType.pk });
        });
        setResponse({ ...res.data, data: newData });
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [userQuery]);

  const [isXLSXDownloading, setIsXLSXDownloading] = useState(false);

  const handleXLSXDownload = async (orgType, orgActiveStatus) => {
    setIsXLSXDownloading(true);
    let url = `accounts/export_org_products/?org_type=${orgType}&org_active_status=${orgActiveStatus}`;

    await axiosInstance(url, {
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        setIsXLSXDownloading(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `org_products.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setIsXLSXDownloading(false);
        // NotificationService.success('Downloading Failed');
      });
  };
  const [orgType, setOrgType] = useState("all");
  const [orgActiveStatus, setOrgActiveStatus] = useState("all");
  const { accountType } = useSelector((state) => state.globalAuth);
  return (
    <div className="h-screen mr-2 overflow-y-auto">
      <div className="flex items-center justify-between px-2 py-2 my-2 text-base font-semibold bg-white border rounded-lg">
        <div className="w-[40%]">Org Products</div>
        <div className="flex w-[60%] justify-end gap-x-2">
          <select
            value={orgType}
            onChange={(e) => {
              setOrgType(e.target.value);
            }}
            className="w-full px-3 py-2 border rounded-lg focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your password"
          >
            <option value={"all"}>all</option>
            {accountType.map((item) => (
              <option key={item.label} value={item.label}>
                {item.label}
              </option>
            ))}
          </select>

          <select
            value={orgActiveStatus}
            onChange={(e) => {
              setOrgActiveStatus(e.target.value);
            }}
            className="w-full px-3 py-2 border rounded-lg focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your password"
          >
            <option value={"all"}>all orgs</option>
            <option value={"active"}>Active orgs</option>
            <option value={"inactive"}>Inactive orgs</option>
          </select>
          <button
            disabled={isXLSXDownloading}
            className="px-2 py-1 text-xs text-white bg-black border rounded-lg disabled:bg-white disabled:text-black disabled:cursor-not-allowed "
            onClick={() => {
              handleXLSXDownload(orgType, orgActiveStatus);
            }}
          >
            Export
          </button>
        </div>
        <div></div>
      </div>

      <div className="mt-3">
        <p className="mb-2 text-sm font-semibold">Search by label</p>
        <Input
          type={"text"}
          value={userSearch}
          placeholder={"Search by label"}
          onChange={(e) => {
            setUserSearch(e.target.value);
          }}
        />
      </div>
      {loading ? (
        <p>Loading....</p>
      ) : (
        <div className="grid grid-cols-3 gap-3 mt-5">
          {response.data.map((card) => {
            return (
              <div key={card.pk} className="relative">
                <Link
                  to={`/bulk-view-org-products/details/?pk=${card.pk}&label=${card.label}`}
                >
                  <button
                    onClick={() => {}}
                    className="flex justify-between w-full h-full p-3 bg-white border cursor-pointer gap-x-3 rounded-xl"
                  >
                    <div className="flex justify-center w-[30%]">
                      <img
                        className="h-auto max-w-full"
                        src={card.meta.icon ? card.meta.icon : card.icon}
                        alt={card.pk}
                      />
                    </div>
                    <div className="w-[70%]">
                      <p className="text-base font-semibold text-left">
                        {card.label}
                      </p>
                      <p className="text-sm font-normal text-left">
                        {card.description}
                      </p>
                      <p className="mt-1 text-sm font-normal text-left">
                        <span className="font-semibold">Count:</span>{" "}
                        {card?.org_count_to_rt_mapping?.org_count
                          ? card?.org_count_to_rt_mapping?.org_count
                          : 0}
                      </p>
                      <p className="mt-1 text-xs font-normal text-left">
                        {card.name} <sub>{card.pk}</sub>
                      </p>
                    </div>
                  </button>
                </Link>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    axiosInstance.post('/accounts/edit_report_type/', {
                      ...card,
                      is_sandbox: false
                    }).then(() => {
                      setResponse(prev => ({
                        ...prev,
                        data: prev.data.filter(item => item.pk !== card.pk)
                      }));
                    }).catch((err) => {
                      console.error('Failed to toggle card:', err);
                    });
                  }}
                  className="absolute flex items-center justify-center w-6 h-6 text-sm font-bold text-white bg-red-500 rounded-full hover:bg-red-600 top-2 right-2"
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BulkViewOrgProducts;
